<script lang="ts">
	//@ts-nocheck
	import { onMount } from 'svelte';
	import Button from '$lib/components/ui/button/button.svelte';
	import { Instagram } from 'lucide-svelte';
	const imageModules = import.meta.glob('$lib/assets/instagram/*.{jpeg,jpg,png}', {
		eager: true,
		query: {
			enhanced: true,
			w: '800;400',
			format: 'webp;jpg'
		}
	});

	// export let userId = '7405458101828732137';
	// export let accessToken =
	// 	'IGQWRNOUoxeUVDeEgyRDRpc3NsYjlrNW9iZAkRVMURmTzBkOEphLUNSYkNTMWhhNHNKaU5ZAdmxlMENjUkVoZAGJmSkZAJVHNFX0M2UjVlLWFwdEx0aFNmajVESU02RUx6ZA3NBOGtZAallFYmlGYmxFMEttTFlsYTY5SG8ZD';
	// let recentMedia: { media_url: string; permalink: string }[] = [];
	// let error: string | null = null;
	// let isLoading = true;

	// onMount(async () => {
	// 	try {
	// 		const fields = 'media_url,permalink'; // Request media URL and permalink
	// 		const apiUrl = `https://graph.instagram.com/${userId}/media?fields=${fields}&access_token=${accessToken}`;
	// 		const response = await fetch(apiUrl);
	// 		console.log(apiUrl);

	// 		if (response.ok) {
	// 			const data = await response.json();
	// 			recentMedia = data.data.slice(0, 6); // Get first 6 media items
	// 		} else {
	// 			error = `Error fetching data: ${response.status} ${response.statusText}`;
	// 		}
	// 	} catch (e) {
	// 		if (e instanceof Error) {
	// 			error = `Network or other error: ${e.message}`;
	// 		} else {
	// 			error = `An unexpected error occured`;
	// 		}
	// 	} finally {
	// 		isLoading = false;
	// 	}
	// });
</script>

<section class="mx-auto flex max-w-7xl flex-col px-4 py-12 lg:py-24">
	<h2
		class="mt-10 scroll-m-20 pb-2 font-heading text-2xl font-semibold tracking-tight transition-colors first:mt-0 lg:text-3xl"
	>
		Connect with us on Instagram
	</h2>
	<div class="mx-auto grid w-full grid-cols-2 gap-4 pt-12 lg:grid-cols-4 lg:grid-rows-2">
		<a
			href="https://www.instagram.com/tassietours_tasmania/"
			target="_blank"
			class="rounded-2-xl group relative col-span-1 row-span-1 lg:odd:col-span-2 lg:odd:row-span-2"
		>
			<enhanced:img
				src={Object.entries(imageModules)[0][1].default}
				alt="Instagram Post - @tassietours_tasmania"
				class="aspect-square w-full w-full rounded-2xl object-cover"
				loading="lazy"
				sizes="(min-width: 1024px) 25vw, 50vw"
			/>
			<div
				class="absolute inset-0 rounded-2xl bg-foreground/0 mix-blend-multiply transition-all group-hover:bg-foreground/20"
			></div>
			<Instagram class="absolute bottom-2 right-2 h-4 w-4 text-background/80 lg:h-8 lg:w-8" />
		</a>
		<a
			href="https://www.instagram.com/tassietours_tasmania/"
			target="_blank"
			class="rounded-2-xl group relative col-span-1 row-span-1 lg:hidden lg:odd:col-span-2 lg:odd:row-span-2"
		>
			<enhanced:img
				src={Object.entries(imageModules)[1][1].default}
				alt="Instagram Post - @tassietours_tasmania"
				class="aspect-square w-full w-full rounded-2xl object-cover"
				loading="lazy"
				sizes="(min-width: 1024px) 25vw, 50vw"
			/>
			<div
				class="absolute inset-0 rounded-2xl bg-foreground/0 mix-blend-multiply transition-all group-hover:bg-foreground/20"
			></div>
			<Instagram class="absolute bottom-2 right-2 h-6 w-6 text-background/60" />
		</a>
		{#each Object.entries(imageModules).slice(2) as [_path, module]}
			<a
				href="https://www.instagram.com/tassietours_tasmania/"
				target="_blank"
				rel="noopener noreferrer"
				class="relative w-full"
			>
				<enhanced:img
					src={module.default}
					alt="Instagram Post - @tassietours_tasmania"
					class="aspect-square w-full rounded-2xl object-cover"
					loading="lazy"
					sizes="(min-width: 1024px) 25vw, 50vw"
				/>
				<div
					class="absolute inset-0 rounded-2xl bg-foreground/0 mix-blend-multiply transition-all group-hover:bg-foreground/20"
				></div>
				<Instagram class="absolute bottom-2 right-2 h-6 w-6 text-background/60" />
			</a>
		{/each}
	</div>
	<div class="">
		<Button
			class="py-0"
			variant="link"
			href="https://www.instagram.com/tassietours_tasmania/"
			target="_blank">@tassietours_tasmania</Button
		>
	</div>
</section>
